// Multi-language translations for Emergent Billing
// Used for: sidebar menu, document texts (on PDFs/emails), key UI labels
// Admin interface stays Dutch, but document output can be per-language

const translations = {
  nl: {
    // Document labels
    factuur: 'Factuur', offerte: 'Offerte', bestelbon: 'Bestelbon',
    leverbon: 'Leveringsbon', proforma: 'Proforma factuur', creditnota: 'Creditnota',
    // PDF/Document text
    aan: 'Aan', van: 'Van', datum: 'Datum', vervaldag: 'Vervaldag', referentie: 'Referentie',
    omschrijving: 'Omschrijving', aantal: 'Aantal', prijs: 'Prijs', btw: 'BTW', totaal: 'Totaal',
    subtotaal: 'Subtotaal', excl_btw: 'Excl. BTW', korting: 'Korting',
    betaling: 'Betaling', mededeling: 'Mededeling', betaalwijze: 'Betaalwijze',
    status: 'Status', leveringsadres: 'Leveringsadres',
    afdrukken: 'Afdrukken / Opslaan als PDF',
    // Email
    email_aanhef: 'Geachte',
    email_bijlage: 'In bijlage vindt u',
    email_bedrag: 'voor een totaalbedrag van',
    email_betaling: 'Gelieve dit bedrag over te schrijven op',
    email_mededeling: 'met mededeling',
    email_groet: 'Met vriendelijke groeten',
    // Sidebar
    dashboard: 'Dashboard', klanten: 'Klanten', artikels: 'Artikels',
    kassa: 'Kassaverkoop', bank: 'Bankverrichtingen', voorraad: 'Voorraad',
    instellingen: 'Instellingen', rapportage: 'Rapportage',
  },
  fr: {
    factuur: 'Facture', offerte: 'Devis', bestelbon: 'Bon de commande',
    leverbon: 'Bon de livraison', proforma: 'Facture proforma', creditnota: 'Note de crédit',
    aan: 'À', van: 'De', datum: 'Date', vervaldag: 'Échéance', referentie: 'Référence',
    omschrijving: 'Description', aantal: 'Quantité', prijs: 'Prix', btw: 'TVA', totaal: 'Total',
    subtotaal: 'Sous-total', excl_btw: 'Hors TVA', korting: 'Remise',
    betaling: 'Paiement', mededeling: 'Communication', betaalwijze: 'Mode de paiement',
    status: 'Statut', leveringsadres: 'Adresse de livraison',
    afdrukken: 'Imprimer / Enregistrer en PDF',
    email_aanhef: 'Cher/Chère',
    email_bijlage: 'Veuillez trouver ci-joint',
    email_bedrag: 'pour un montant total de',
    email_betaling: 'Veuillez virer ce montant sur',
    email_mededeling: 'avec la communication',
    email_groet: 'Cordialement',
    dashboard: 'Tableau de bord', klanten: 'Clients', artikels: 'Articles',
    kassa: 'Caisse', bank: 'Opérations bancaires', voorraad: 'Stock',
    instellingen: 'Paramètres', rapportage: 'Rapports',
  },
  en: {
    factuur: 'Invoice', offerte: 'Quote', bestelbon: 'Purchase Order',
    leverbon: 'Delivery Note', proforma: 'Proforma Invoice', creditnota: 'Credit Note',
    aan: 'To', van: 'From', datum: 'Date', vervaldag: 'Due Date', referentie: 'Reference',
    omschrijving: 'Description', aantal: 'Quantity', prijs: 'Price', btw: 'VAT', totaal: 'Total',
    subtotaal: 'Subtotal', excl_btw: 'Excl. VAT', korting: 'Discount',
    betaling: 'Payment', mededeling: 'Reference', betaalwijze: 'Payment Method',
    status: 'Status', leveringsadres: 'Delivery Address',
    afdrukken: 'Print / Save as PDF',
    email_aanhef: 'Dear',
    email_bijlage: 'Please find attached',
    email_bedrag: 'for a total amount of',
    email_betaling: 'Please transfer this amount to',
    email_mededeling: 'with reference',
    email_groet: 'Kind regards',
    dashboard: 'Dashboard', klanten: 'Customers', artikels: 'Products',
    kassa: 'Point of Sale', bank: 'Banking', voorraad: 'Inventory',
    instellingen: 'Settings', rapportage: 'Reports',
  },
  de: {
    factuur: 'Rechnung', offerte: 'Angebot', bestelbon: 'Bestellung',
    leverbon: 'Lieferschein', proforma: 'Proformarechnung', creditnota: 'Gutschrift',
    aan: 'An', van: 'Von', datum: 'Datum', vervaldag: 'Fälligkeitsdatum', referentie: 'Referenz',
    omschrijving: 'Beschreibung', aantal: 'Menge', prijs: 'Preis', btw: 'MwSt', totaal: 'Gesamt',
    subtotaal: 'Zwischensumme', excl_btw: 'Exkl. MwSt', korting: 'Rabatt',
    betaling: 'Zahlung', mededeling: 'Mitteilung', betaalwijze: 'Zahlungsart',
    status: 'Status', leveringsadres: 'Lieferadresse',
    afdrukken: 'Drucken / Als PDF speichern',
    email_aanhef: 'Sehr geehrte/r',
    email_bijlage: 'Anbei finden Sie',
    email_bedrag: 'über einen Gesamtbetrag von',
    email_betaling: 'Bitte überweisen Sie diesen Betrag auf',
    email_mededeling: 'mit dem Verwendungszweck',
    email_groet: 'Mit freundlichen Grüßen',
    dashboard: 'Dashboard', klanten: 'Kunden', artikels: 'Artikel',
    kassa: 'Kasse', bank: 'Bankgeschäfte', voorraad: 'Lager',
    instellingen: 'Einstellungen', rapportage: 'Berichte',
  },
};

export const t = (lang, key) => translations[lang]?.[key] || translations.nl[key] || key;
export const LANGS = [
  { code: 'nl', label: 'NL', full: 'Nederlands' },
  { code: 'fr', label: 'FR', full: 'Français' },
  { code: 'en', label: 'EN', full: 'English' },
  { code: 'de', label: 'DE', full: 'Deutsch' },
];
export default translations;
